import { useState } from 'react';

export function Newsletter() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  return (
    <div className="newsletter-section">
      <h3 className="text-xl font-bold text-white mb-6">Stay in the Loop</h3>
      
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 mb-4">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className="flex-1 px-4 py-3 rounded-lg bg-primary-muted border border-primary-light text-white placeholder-primary-light focus:outline-none focus:ring-2 focus:ring-primary-light focus:border-transparent"
          required
        />
        <button
          type="submit"
          className="px-8 py-3 bg-white text-primary-slate font-semibold rounded-lg hover:bg-gray-100 transition-colors duration-200"
        >
          Sign Up
        </button>
      </form>
      
      <p className="text-xs text-slate-300 leading-relaxed">
        This form is protected by reCAPTCHA and the Google{' '}
        <a
          href="https://policies.google.com/privacy"
          className="text-slate-300 underline hover:text-white"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        {' '}and{' '}
        <a
          href="https://policies.google.com/terms"
          className="text-slate-300 underline hover:text-white"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>
        {' '}apply.
      </p>
    </div>
  );
}